import React, { FunctionComponent } from 'react'
import CollapsingItem from '../../Common/CollapsingItem'
import Row from '../../Common/Row'
import { Text } from '@wework/dieter-ui'
import css from './Schedule.module.scss'
import ScheduleTag, { ScheduleTags } from './ScheduleTag'
import classnames from 'classnames'

interface ScheduleProps {
  space: any
}

type ScheduleInterval = 'Daily' | 'Weekday'

interface ScheduleData {
  id: string
  tags: Array<ScheduleTags>
  homeInterval: ScheduleInterval
  visitingInterval: ScheduleInterval
  homeTimeFrame: string
  visitingTimeFrame: string
}

const Schedule: FunctionComponent<ScheduleProps> = ({ space }) => {
  const schedules: Array<ScheduleData> = space.schedules || [
    {
      id: '1',
      tags: ['PHYSICAL', 'HOTDESK', 'DIGITAL', 'PXWE', 'GLOBAL ACCESS'],
      homeInterval: 'Daily',
      homeTimeFrame: '0800 - 1800',
      visitingInterval: 'Weekday',
      visitingTimeFrame: '0800 - 1800',
    },
    {
      id: '2',
      tags: ['EMPLOYEE'],
      homeInterval: 'Daily',
      homeTimeFrame: '0800 - 2100',
      visitingInterval: 'Daily',
      visitingTimeFrame: '0800 - 2100',
    },
    {
      id: '3',
      tags: ['ON DEMAND', 'ON DEMAND SUBSCRIPTION'],
      homeInterval: 'Weekday',
      homeTimeFrame: '0930 - 1730',
      visitingInterval: 'Weekday',
      visitingTimeFrame: '0930 - 1730',
    },
  ]
  const getScheduleItem: (priceData: ScheduleData) => JSX.Element = ({
    id,
    tags,
    homeInterval,
    homeTimeFrame,
    visitingInterval,
    visitingTimeFrame,
  }) => {
    return (
      <div key={id} className={css.scheduleItem}>
        <Row className={classnames(css.scheduleTags, css.bottomMargin)}>
          {tags.map(tag => (
            <ScheduleTag key={tag} type={tag} />
          ))}
        </Row>
        <Text className={css.scheduleBoldText}>Home</Text>
        <Row className={css.bottomMargin} justify={'space-between'}>
          <Text className={css.scheduleText}>{homeInterval}</Text>
          <Text className={css.scheduleText}>{homeTimeFrame}</Text>
        </Row>
        <Text className={css.scheduleBoldText}>Visiting</Text>
        <Row justify={'space-between'}>
          <Text className={css.scheduleText}>{visitingInterval}</Text>
          <Text className={css.scheduleText}>{visitingTimeFrame}</Text>
        </Row>
      </div>
    )
  }

  return (
    <CollapsingItem title={'Schedule'}>
      {schedules.map(priceData => getScheduleItem(priceData))}
    </CollapsingItem>
  )
}

export default Schedule
